<template>
	<wd-tabbar
		fixed
		v-model="tabbarStore.curIdx"
		:bordered="false"
		inactiveColor="#666666"
		safeAreaInsetBottom
		placeholder
		custom-class="witTabbar"
		@change="selectTabBar"
	>
		<template v-for="(item, idx) in tabbarList" :key="item.path">
			<wd-tabbar-item
				v-if="item.iconType === 'wot'"
				v-bind="getTabbarProps(item)"
				:title="item.text"
				:icon="item.icon"
			></wd-tabbar-item>
			<wd-tabbar-item
				v-else-if="item.iconType === 'iconfont'"
				v-bind="getTabbarProps(item)"
				:title="item.text"
			>
				<template #icon>
					<view
						h-40rpx
						w-40rpx
						:class="[
							item.icon,
							idx === tabbarStore.curIdx ? 'is-active' : 'is-inactive',
						]"
					></view>
				</template>
			</wd-tabbar-item>
			<wd-tabbar-item
				v-else-if="item.iconType === 'local'"
				v-bind="getTabbarProps(item)"
				:title="item.text"
				custom-class="witTabbarItem"
				:class="[idx === tabbarStore.curIdx ? 'is-active-item' : '']"
			>
				<template #icon>
					<image
						v-if="idx !== tabbarStore.curIdx"
						:src="item.iconPath"
						class="tabbar-icon"
					/>
					<image
						v-if="idx == tabbarStore.curIdx"
						:src="item.selectedIconPath"
						class="tabbar-icon"
					/>
				</template>
			</wd-tabbar-item>
		</template>
	</wd-tabbar>
</template>
<script lang="ts">
export default {
	options: {
		styleIsolation: "shared",
	},
};
</script>
<script setup lang="ts">
// unocss icon 默认不生效，需要在这里写一遍才能生效！注释掉也是生效的，但是必须要有！
// i-carbon-code
import { tabBar } from "@/pages.json";
import { tabbarStore } from "./tabbar";
import { useMessageStore } from "/@/store/modules/message";
const messageStore = useMessageStore();

/** tabbarList 里面的 path 从 pages.config.ts 得到 */
const tabbarList = tabBar.list.map((item) => ({
	...item,
	path: `/${item.pagePath}`,
}));

function selectTabBar({ value: index }: { value: number }) {
	const url = tabbarList[index].path;
	tabbarStore.setCurIdx(index);
	uni.switchTab({ url });
}

const getTabbarProps = (item) => {
	const isMessageTab = item.pagePath === "pages/message/index";
	return {
		// && !messageStore.receiveMsgSwitch
		// 开启消息提示功能时 红点提示
		// isDot: isMessageTab ? messageStore.unread : false,
		// value: isMessageTab ? messageStore.unread : "",
	};
};

onLoad(() => {
	// 解决原生 tabBar 未隐藏导致有2个 tabBar 的问题
	uni.hideTabBar({
		fail(err) {
			// console.log('hideTabBar fail: ', err)
		},
		success(res) {
			// console.log('hideTabBar success: ', res)
		},
	});
	// 判断当前页页面是属于哪一个 tabBar，重置当前选中项
	let pages = getCurrentPages();
	let curPage = pages[pages.length - 1];
	let curPagePath = curPage.route;
	tabbarList.forEach((item, index) => {
		if (item.pagePath === curPagePath) {
			tabbarStore.setCurIdx(index);
		}
	});
});
</script>
<style lang="scss" scoped>
::v-deep {
	.witTabbar {
		display: flex;
		align-items: center;
		justify-content: space-around;
		box-shadow: 0px -1px 10px 0px #7d7e8080;
	}
	.wd-tabbar-item__body-title {
		font-size: 20rpx;
	}

	.wd-badge__content {
		height: 20rpx;
		line-height: 20rpx;
		font-size: 20rpx;
		padding: 2rpx 8rpx;
		border: unset;
		top: 6rpx !important;
		right: 10rpx !important;
	}

	.wd-tabbar-item__body .is-active {
		color: #fff !important;
	}

	.is-active-item {
		width: 160rpx !important;
		height: 76rpx !important;
		border-radius: 40rpx;
		background-color: #4d75d0;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.witTabbarItem {
		width: 160rpx !important;
		flex: none;
	}
}

.tabbar-icon {
	width: 32rpx;
	height: 32rpx;
}
</style>
